<section class="bg-half-170 d-table w-100" id="home"
         style="background: url('assets/images/enterprise.png') center center;">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-7 col-md-6">
                <div class="title-heading mt-4">
                    <h1 class="display-4 font-weight-bold text-white title-dark mb-3">Rate us</h1>
                </div>
            </div>
            <!--end col-->

            <div class="col-lg-5 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                <div class="card login_page shadow rounded border-0 ml-lg-5">
                    <div class="card-body">
                        <h5 class="card-title">You can start rivew here</h5>

                        <form [formGroup]="reviewForm" class="login-form">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group position-relative">
                                        <label>Full Name</label>
                                        <i-feather name="user" class="fea icon-sm icons"></i-feather>
                                        <input type="text" class="form-control pl-5" placeholder="Name" name="s" formControlName="name"
                                               required="">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group position-relative">
                                        <label>Your Email</label>
                                        <i-feather name="mail" class="fea icon-sm icons"></i-feather>
                                        <input type="email" class="form-control pl-5" placeholder="Email" name="email" formControlName="email"
                                               required="">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group position-relative">
                                        <label>Review</label>
                                        <i-feather name="info" class="fea icon-sm icons"></i-feather>
                                        <input type="email" class="form-control pl-5" placeholder="Review" name="email" formControlName="review"
                                               required="">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <div class="form-group position-relative">
                                        <label>Rate</label>
                                        <br>
                                        <ngb-rating [(rate)]="currentRate">
                                            <ng-template let-fill="fill" let-index="index">
                                                <span class="star" [class.filled]="fill === 100">&#9733;</span>
                                            </ng-template>
                                        </ngb-rating>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <button class="btn btn-success w-100" (click)="reveiw()">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->

    <div class="container">
        <div class="row py-5 justify-content-center">
            <div class="col-lg-8 text-center">
                <!-- <div id="owl-fade" class="owl-carousel owl-theme"> -->
                <owl-carousel-o i [options]="customOptions2">
                    <ng-template carouselSlide *ngFor="let r of review">
                        <div class="customer-testi text-center mx-4">
                            <img src="assets/3r/user-3331257__340.png"
                                 class="img-fluid avatar avatar-small rounded-circle mx-auto shadow"
                                 alt="">
                            <p class="text-light para-dark h5 font-weight-normal font-italic mt-4">"{{r.review}} "</p>
                            <!--                            <ul class="list-unstyled mb-0">-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                                <li class="list-inline-item"><i class="mdi mdi-star text-warning"></i></li>-->
                            <!--                            </ul>-->
                            <h6 class="text-light title-dark"> {{r.clientName}} </h6>
                        </div>
                        <!--end customer testi-->
                    </ng-template>
                </owl-carousel-o>
                <!-- </div> -->
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
</section>
<!--end section-->
